import * as angular from "angular";
import {DataHubService} from "../modules/DataHubModule";
import {IComponentController} from "angular";
import {DisposeBag} from "../modules/DisposeBag";
import {Guid} from "guid-typescript";
import {QbCustomerContactDto} from "../model/QbCustomerContactDto";

class ContactSelectController implements IComponentController {
    records: QbCustomerContactDto[] = [];
    model: any;
    onSelect: Function;
    required: string;
    placeholder: string;
    showAll: Boolean;
    private disposeBag = new DisposeBag();
    private customerGuid: Guid;

    constructor(private $dataHub: DataHubService, private $scope) {
        $dataHub.bindAllContact(() => this.records, this.disposeBag);
        $dataHub.onConnected(this.reload, this.disposeBag);
    }

    reload = () => {
        this.$dataHub.contactSubscribeAndQuery(this.customerGuid)
            .then(ret => this.records = ret);
    };

    $onInit(): void {
    }

    $onDestroy() {
        this.disposeBag.finalize();
    }

    $onChanges(onChangesObj: angular.IOnChangesObject) {
        this.reload();
    }
}

export default angular.module('component.contactSelect', [])
    .component('contactSelect', {
        template: require('./ContactSelect.html'),
        controller: ContactSelectController,
        bindings: {
            model: '=',
            onSelect: '&',
            required: '=',
            placeholder: '@',
            showAll: '=',
            allowClear: '=',
            customerGuid: '<'
        }
    }).name;
